export enum ClosetPromotionEngagementEventTarget {
  AllItems = 'all_items',
  UserProfile = 'user_profile',
  UserFollow = 'user_follow',
  ItemFavourite = 'item_favourite',
  Item = 'item',
  ViewProfile = 'view_wardrobe',
}

export enum PreCheckoutModal {
  PreCheckout = 'preCheckout',
  PreCheckoutHelp = 'preCheckoutHelp',
  DynamicPricingInfo = 'dynamicPricingInfo',
  GenericErrorModal = 'genericErrorModal',
  None = 'none',
}
